import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'

import { ServerValidationError } from '@/api/shared/types'

import { ParkingService } from '../lib/parking.service'
import { Auto } from '../lib/parking.types'
import { GET_AUTOS } from './useAutos'

type AutosResponse = {
  data: Auto[]
}

type ReorderAutosContext = {
  previousAutos?: AutosResponse
}

export const useReorderAutos = () => {
  const queryClient = useQueryClient()

  return useMutation<
    AxiosResponse<null>,
    AxiosError<ServerValidationError>,
    Auto[],
    ReorderAutosContext
  >({
    mutationFn: autos =>
      ParkingService.reorderAutos({ autosId: autos.map(({ id }) => id) }),
    onMutate: async autos => {
      await queryClient.cancelQueries({ queryKey: [GET_AUTOS] })

      const previousAutos = queryClient.getQueryData<AutosResponse>([GET_AUTOS])

      queryClient.setQueryData<AutosResponse>([GET_AUTOS], { data: autos })

      return { previousAutos }
    },
    onError: (_error, _autos, context) =>
      queryClient.setQueryData([GET_AUTOS], context?.previousAutos),
    onSettled: () => queryClient.invalidateQueries({ queryKey: [GET_AUTOS] })
  })
}
